import { Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Layout from './components/Layout';
import Home from './pages/Home';
import Reference from './pages/Reference';
import Upload from './pages/Upload';
import Generate from './pages/Generate';
import Result from './pages/Result';
import Settings from './pages/Settings';
import Auth from './pages/Auth';
import V3 from './pages/V3';
import History from './pages/History';
import HistoryDetail from './pages/HistoryDetail';

function App() {
  return (
    <AnimatePresence mode="wait">
      <Routes>
        <Route path="/auth" element={<Auth />} />
        <Route path="/*" element={
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/reference" element={<Reference />} />
              <Route path="/upload" element={<Upload />} />
              <Route path="/generate" element={<Generate />} />
              <Route path="/result/:id" element={<Result />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/v3" element={<V3 />} />
              <Route path="/history" element={<History />} />
              <Route path="/history/:id" element={<HistoryDetail />} />
            </Routes>
          </Layout>
        } />
      </Routes>
    </AnimatePresence>
  );
}

export default App;
